module.exports = new __parcel__URL__("view-back.c5237e00.svg").toString();